export default __webpack_public_path__ + "locales/sl/FilesSettings.json?hash=8561d44081a581a5b10746e263b450da";